import JobZImage from "../../../../common/jobz-img";
import { NavLink } from "react-router-dom";
import { publicUser } from "../../../../../globals/route-names";
import { loadScript, publicUrlFor } from "../../../../../globals/constants";
import { useEffect } from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";

function HomePage() {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        loadScript("js/custom.js")
    })

    return (
        <>
            {/*Banner Start*/}
            <div className="twm-home-6-banner-section">
                <div className="container">
                    <div className="row">
                        {/*Left Section*/}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="twm-bnr-left-section">
                                <div className="twm-bnr-title-small">
                                    <div className="bnr-title-bedge">
                                        <i className="fa fa-check" />
                                    </div>
                                    {t("Stay connect to get upcoming job with")}
                                    <span className="site-text-primary">Jobzilla</span>
                                </div>
                                <div className="twm-bnr-title-large">
                                    {t("Get a job offer from a Canadian recruiter")}
                                    {/* Obtenir une offre d’emploi d’un recruteur canadien */}
                                </div>
                                <div className="twm-bnr-discription">
                                    {t("We post your CV on our platform and send your CV to the relevant recruiters every day.")}
                                    {/* Nous diffusons votre CV sur notre plateforme et nous envoyons votre CV aux recruteurs correspondants chaque jour. */}
                                </div>

                            </div>
                        </div>
                        {/*right Section*/}
                        <div className="col-xl-6 col-lg-6 col-md-12 twm-bnr-right-section">
                            <div className="twm-bnr-right-content">
                                <div className="bnr-media">
                                    <JobZImage src="images/home-6/banner-pic.png" alt="#" />
                                </div>
                                <div className="bnr-bg-circle">
                                    <span />
                                </div>
                                <div className="bnr-bg-icons">
                                    <div className="icon-plus1 bounce"><i className="fa fa-plus" /></div>
                                    <div className="icon-plus2 bounce2"><i className="fa fa-plus" /></div>
                                    <div className="icon-plus3 bounce"><i className="fa fa-plus" /></div>
                                    <div className="icon-ring1 bounce2" />
                                    <div className="icon-ring2 bounce" />
                                    <div className="icon-ring3 bounce2" />
                                    <div className="bnr-block-1 bounce">
                                        <div className="bnr-block-1-content">
                                            <div className="media"><JobZImage src="images/home-6/cv-icon.png" alt="" /></div>
                                            <h3 className="title">{t("Upload CV")}</h3>
                                        </div>
                                    </div>
                                    <div className="bnr-block-2 bounce2">
                                        <div className="bnr-block-2-content">
                                            <div className="bnr-block-2-bag">
                                                <span><JobZImage src="images/home-6/bag.png" alt="" /></span>
                                            </div>
                                            <div className="bnr-block-2-content-top">
                                                <h3 className="title">25 k</h3>
                                                <div className="media"><JobZImage src="images/home-6/graph-icon.png" alt="" /></div>
                                            </div>
                                            <div className="bnr-block-2-content-bottom">{t("People Got Hired")}</div>
                                        </div>
                                    </div>
                                    <div className="bnr-block-3 bounce">
                                        <JobZImage src="images/home-6/pdf-file.png" alt="#" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/*Banner End*/}
            {/* HOW IT WORK SECTION START */}
            <div className="section-full p-t120 p-b90 site-bg-white twm-how-it-work-area">
                <div className="container">
                    {/* title="" START*/}
                    <div className="section-head center wt-small-separator-outer">
                        <div className="wt-small-separator site-text-primary">
                            {/* <div>Processus de travail</div> */}
                            <div>{t("Work process")}</div>
                        </div>
                        <h2 className="wt-title">{t("How JobContact works")}</h2>
                    </div>
                    {/* title="" END*/}
                    <div className="twm-how-it-work-section">
                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps">
                                    <span className="twm-large-number">01</span>
                                    <div className="twm-w-pro-top bg-clr-sky">
                                        <div className="twm-media">
                                            <span><JobZImage src="images/work-process/icon1.png" alt="icon1" /></span>
                                        </div>
                                        <h4 className="twm-title">{t("Create an")}<br />{t("account")}</h4>
                                    </div>
                                    <p>{t("Create your profile and upload your CV")}</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps">
                                    <span className="twm-large-number">02</span>
                                    <div className="twm-w-pro-top bg-clr-pink">
                                        <div className="twm-media">
                                            <span><JobZImage src="images/work-process/icon2.png" alt="icon1" /></span>
                                        </div>
                                        <h4 className="twm-title">{t("Apply")} <br />
                                            {t("for your dream job")}</h4>
                                    </div>
                                    <p>{t("Select the jobs and locations you are looking for.")}</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps">
                                    <span className="twm-large-number">03</span>
                                    <div className="twm-w-pro-top bg-clr-green">
                                        <div className="twm-media">
                                            <span><JobZImage src="images/work-process/icon3.png" alt="icon1" /></span>
                                        </div>
                                        <h4 className="twm-title">{t("Download")}  <br />{t("your CV")}</h4>
                                    </div>
                                    <p>{t("CV Diffusion displays your profile on the platform and applies on your behalf.")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* HOW IT WORK SECTION END */}
            {/* EXPLORE NEW LIFE START */}
            <div className="section-full p-t120 p-b120 twm-explore-area bg-cover " style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-1.jpg")})` }}>
                <div className="container">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-lg-4 col-md-12">
                                <div className="twm-explore-media-wrap">
                                    <div className="twm-media">
                                        <JobZImage src="images/gir-large.png" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-12">
                                <div className="twm-explore-content-outer">
                                    <div className="twm-explore-content">
                                        <div className="twm-l-line-1" />
                                        <div className="twm-l-line-2" />
                                        <div className="twm-r-circle-1" />
                                        <div className="twm-r-circle-2" />
                                        <div className="twm-title-small">{t("Explorez une nouvelle vie")}</div>
                                        <div className="twm-title-large">
                                            <h2>{t("Give your job search a boost.")}</h2>
                                            <p>{t("Submit your resume. Every day, recruiters apply on your behalf to the right recruiters in just a few clicks.")}</p>
                                        </div>
                                        <div className="twm-upload-file">
                                            <button type="button" className="site-button">{t("Submit your application")}<i className="feather-upload" /></button>
                                        </div>
                                    </div>
                                    <div className="twm-bold-circle-right" />
                                    <div className="twm-bold-circle-left" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* EXPLORE NEW LIFE END */}
            {/* CANDIDATES START */}
            <div className="section-full p-t120 p-b90 site-bg-white twm-candidate-h-page7-wrap pos-relative ">
                <div className="container">
                    {/* title="" START*/}
                    <div className="section-head center wt-small-separator-outer">
                        <div className="wt-small-separator site-text-primary">
                            <div>Candidates</div>
                        </div>
                        <h2 className="wt-title">{t("Featured Candidates")}</h2>
                    </div>
                    {/* title="" END*/}
                </div>
                <div className="container-fluid">
                    <div className="section-content">
                        <div className="twm-candidate-h-page7">
                            <div className="row d-flex justify-content-center m-b30">
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="twm-candidates-grid-h-page7 m-b30">
                                        <div className="twm-top-section-content">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src="images/candidates/pic1.jpg" alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <div className="twm-candidates-tag"><span>Featured</span></div>
                                                <NavLink to={publicUser.candidate.DETAIL1} className="twm-job-title">
                                                    <h4>Wanda Smith</h4>
                                                </NavLink>
                                                <p>Charted Accountant</p>
                                            </div>
                                        </div>
                                        <div className="twm-fot-content">
                                            <div className="twm-left-info">
                                                <p className="twm-candidate-address"><i className="feather-map-pin" />New York</p>
                                                <div className="twm-jobs-vacancies">$20<span>/ Day</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="twm-candidates-grid-h-page7 m-b30">
                                        <div className="twm-top-section-content">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src="images/candidates/pic2.jpg" alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <div className="twm-candidates-tag"><span>Featured</span></div>
                                                <NavLink to={publicUser.candidate.DETAIL1} className="twm-job-title">
                                                    <h4>Peter Hawkins</h4>
                                                </NavLink>
                                                <p>Medical Professed</p>
                                            </div>
                                        </div>
                                        <div className="twm-fot-content">
                                            <div className="twm-left-info">
                                                <p className="twm-candidate-address"><i className="feather-map-pin" />New York</p>
                                                <div className="twm-jobs-vacancies">$7<span>/ Hour</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="twm-candidates-grid-h-page7 m-b30">
                                        <div className="twm-top-section-content">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src="images/candidates/pic3.jpg" alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <div className="twm-candidates-tag"><span>Featured</span></div>
                                                <NavLink to={publicUser.candidate.DETAIL1} className="twm-job-title">
                                                    <h4>Ralph Johnson</h4>
                                                </NavLink>
                                                <p>Bank Manger</p>
                                            </div>
                                        </div>
                                        <div className="twm-fot-content">
                                            <div className="twm-left-info">
                                                <p className="twm-candidate-address"><i className="feather-map-pin" />New York</p>
                                                <div className="twm-jobs-vacancies">$180<span>/ Day</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="twm-candidates-grid-h-page7 m-b30">
                                        <div className="twm-top-section-content">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src="images/candidates/pic4.jpg" alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <div className="twm-candidates-tag"><span>Featured</span></div>
                                                <NavLink to={publicUser.candidate.DETAIL1} className="twm-job-title">
                                                    <h4>Randall Henderson </h4>
                                                </NavLink>
                                                <p>IT Contractor</p>
                                            </div>
                                        </div>
                                        <div className="twm-fot-content">
                                            <div className="twm-left-info">
                                                <p className="twm-candidate-address"><i className="feather-map-pin" />New York</p>
                                                <div className="twm-jobs-vacancies">$90<span>/ Week</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="twm-candidates-grid-h-page7 m-b30">
                                        <div className="twm-top-section-content">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src="images/candidates/pic5.jpg" alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <div className="twm-candidates-tag"><span>Featured</span></div>
                                                <NavLink to={publicUser.candidate.DETAIL1} className="twm-job-title">
                                                    <h4>Randall Warren</h4>
                                                </NavLink>
                                                <p>Digital &amp; Creative</p>
                                            </div>
                                        </div>
                                        <div className="twm-fot-content">
                                            <div className="twm-left-info">
                                                <p className="twm-candidate-address"><i className="feather-map-pin" />New York</p>
                                                <div className="twm-jobs-vacancies">$95<span>/ Day</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="twm-candidates-grid-h-page7 m-b30">
                                        <div className="twm-top-section-content">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src="images/candidates/pic6.jpg" alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <div className="twm-candidates-tag"><span>Featured</span></div>
                                                <NavLink to={publicUser.candidate.DETAIL1} className="twm-job-title">
                                                    <h4>Christina Fischer </h4>
                                                </NavLink>
                                                <p>Charity &amp; Voluntary</p>
                                            </div>
                                        </div>
                                        <div className="twm-fot-content">
                                            <div className="twm-left-info">
                                                <p className="twm-candidate-address"><i className="feather-map-pin" />New York</p>
                                                <div className="twm-jobs-vacancies">$19<span>/ Hour</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="twm-candidates-grid-h-page7 m-b30">
                                        <div className="twm-top-section-content">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src="images/candidates/pic7.jpg" alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <div className="twm-candidates-tag"><span>Featured</span></div>
                                                <NavLink to={publicUser.candidate.DETAIL1} className="twm-job-title">
                                                    <h4>Wanda Willis </h4>
                                                </NavLink>
                                                <p>Marketing &amp; PR</p>
                                            </div>
                                        </div>
                                        <div className="twm-fot-content">
                                            <div className="twm-left-info">
                                                <p className="twm-candidate-address"><i className="feather-map-pin" />New York</p>
                                                <div className="twm-jobs-vacancies">$12<span>/ Day</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="twm-candidates-grid-h-page7 m-b30">
                                        <div className="twm-top-section-content">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src="images/candidates/pic8.jpg" alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <div className="twm-candidates-tag"><span>Featured</span></div>
                                                <NavLink to={publicUser.candidate.DETAIL1} className="twm-job-title">
                                                    <h4>Peter Hawkins</h4>
                                                </NavLink>
                                                <p>Public Sector</p>
                                            </div>
                                        </div>
                                        <div className="twm-fot-content">
                                            <div className="twm-left-info">
                                                <p className="twm-candidate-address"><i className="feather-map-pin" />New York</p>
                                                <div className="twm-jobs-vacancies">$7<span>/ Hour</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center m-b30">
                                <NavLink to={publicUser.candidate.LIST} className=" site-button">{t("All  Candidates")}</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="twm-bg-candi-pattern" />
                <div className="container">
                    <div className="twm-j-ofr-wrap">
                        <div className="twm-j-ofr-content" style={{ backgroundImage: `url(${publicUrlFor("images/home-7/ofr-bg.jpg")})` }}>
                            <div className="row">
                                <div className="col-lg-7 col-md-12">
                                    <div className="twm-j-ofr-map-content">
                                        {/* title="" START*/}
                                        <div className="section-head left wt-small-separator-outer">
                                            <h2 className="wt-title">{t("We also have ")}<span className="site-text-primary">{t("job offers")}</span> {t("in other countries")}</h2>
                                        </div>
                                        {/* title="" END*/}
                                        <div className="twm-j-ofr-map-list">
                                            <ul>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/denmark.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">Denmark</h4>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/france.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">France</h4>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/netherlands.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">Netherlands</h4>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/poland.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">Poland</h4>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/portugal.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">Portugal</h4>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/spain.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">Spain</h4>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/turkey.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">Turkey</h4>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/uae.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">UAE</h4>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="flag-list">
                                                        <span><JobZImage src="images/home-7/flag-icon/united-kingdom.jpg" alt="#" /></span>
                                                        <h4 className="flat-name">UK</h4>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="twm-read-more">
                                            <NavLink to={publicUser.pages.ABOUT} className="site-button">{t("More Offers")}</NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-12">
                                    <div className="twm-j-ofr-map">
                                        <div className="twm-media">
                                            <JobZImage src="images/home-7/map-img.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* CANDIDATES END */}



            {/* TESTIMONIAL SECTION START */}
            <div className="section-full p-t120 p-b90 site-bg-white twm-testimonial-v-area">
                <div className="container">
                    <div className="section-content">
                        <div className="twm-testimonial-v-section">
                            <div className="row">
                                <div className="col-xl-5 col-lg-12 col-md-12">
                                    <div className="twm-explore-content-outer2">
                                        <div className="twm-explore-top-section">
                                            {/* title="" START*/}
                                            <div className="section-head left wt-small-separator-outer">
                                                <div className="wt-small-separator site-text-primary">
                                                    <div>{t("Customer Testimonials")} </div>
                                                </div>
                                                <h2>{t("What our customers say about us")}</h2>
                                                <p>You need to create an account to find the best and preferred job. lorem
                                                    Ipsum is simply dummy text of the printing and typesetting the standard dummy text ever since the  when an printer took.</p>
                                            </div>
                                            {/* title="" END*/}
                                            <div className="twm-read-more">
                                                <NavLink to={publicUser.pages.ABOUT} className="site-button">{t("Show All Quotes")}</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-12 col-md-12">
                                    <div className="v-testimonial-wrap">
                                        <div className="v-testi-dotted-pic">
                                            <JobZImage src="images/home-6/testimonial/dotted-block.png" alt="#" />
                                        </div>
                                        {/* Swiper */}
                                        <div className="swiper-container v-testimonial-slider">
                                            <div className="swiper-wrapper">
                                                {/*block 1*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="twm-testi-media">
                                                            <JobZImage src="images/home-6/testimonial/pic1.jpg" alt="#" />
                                                        </div>
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i className="fa fa-quote-left" /></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">I have minim mollit non deserunt ullamco est sit aliqua
                                                                dolor do Eam et sint. Velit officia consequat.
                                                            </div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">Guy Hawkins</div>
                                                                <div className="twm-testi-position">UI/UX Designer</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 2*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="twm-testi-media">
                                                            <JobZImage src="images/home-6/testimonial/pic2.jpg" alt="#" />
                                                        </div>
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i className="fa fa-quote-left" /></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">I have minim mollit non deserunt ullamco est sit aliqua
                                                                dolor do Eam et sint. Velit officia consequat.
                                                            </div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">Guy Hawkins</div>
                                                                <div className="twm-testi-position">UI/UX Designer</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 3*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="twm-testi-media">
                                                            <JobZImage src="images/home-6/testimonial/pic3.jpg" alt="#" />
                                                        </div>
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i className="fa fa-quote-left" /></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">I have minim mollit non deserunt ullamco est sit aliqua
                                                                dolor do Eam et sint. Velit officia consequat.
                                                            </div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">Guy Hawkins</div>
                                                                <div className="twm-testi-position">UI/UX Designer</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 4*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="twm-testi-media">
                                                            <JobZImage src="images/home-6/testimonial/pic1.jpg" alt="#" />
                                                        </div>
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i className="fa fa-quote-left" /></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">I have minim mollit non deserunt ullamco est sit aliqua
                                                                dolor do Eam et sint. Velit officia consequat.
                                                            </div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">Guy Hawkins</div>
                                                                <div className="twm-testi-position">UI/UX Designer</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Add Pagination */}
                                            <div className="swiper-pagination" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* TESTIMONIAL SECTION END */}

            {/* SUBSCRIBE SECTION START */}
            <div className="section-full twm-hpage-6-subs-wrap bg-cover " style={{ backgroundImage: `url(${publicUrlFor("images/home-6/subscribe-bg.jpg")})` }}>
                <div className="container">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-lg-7 col-md-12">
                                <div className="twm-hpage-6-getintouch">
                                    <div className="callus-bg-box">
                                        <div className="callus-bg-box-shadow" />
                                    </div>
                                    <div className="twm-hpage-6-getintouch-title">
                                        <div className="wt-title-small">Latest Blog</div>
                                        <h2 className="wt-title">
                                            Get your <span>Free</span>
                                            web consultation
                                        </h2>
                                    </div>
                                    <div className="twm-hpage-6-callus">
                                        <div className="callus-icon">
                                            <i className="flaticon-phone" />
                                        </div>
                                        <div className="callus-content">
                                            <div className="callus-number">555-281-5426</div>
                                            <div className="callus-email">Info@jobzilla.com</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12">
                                <div className="twm-hpage-6-subscribe-wrap">
                                    <div className="hpage-6-nw-form-corner-wrap">
                                        <div className="twm-hpage-6-subscribe">
                                            <h3 className="twm-sub-title">Subscribe for free</h3>
                                            <div className="twm-sub-discription">
                                                Join our email subscription now to get updates
                                                on new jobs and notifications.
                                            </div>
                                            <form>
                                                <div className="hpage-6-nw-form">
                                                    <input name="news-letter" className="form-control" placeholder="Enter Your Email" type="text" />
                                                    <button className="hpage-6-nw-form-btn"><i className="fa fa-paper-plane" /></button>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="hpage-6-nw-form-corner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* SUBSCRIBE SECTION END */}
        </>
    )
}

export default HomePage;



// import { useEffect } from "react";4
// import { loadScript, publicUrlFor } from "../../../../../globals/constants";
// import JobZImage from "../../../../common/jobz-img";
// import CountUp from "react-countup";
// import { publicUser } from "../../../../../globals/route-names";
// import { NavLink } from "react-router-dom";

// function Home1Page() {

//     useEffect(() => {
//         loadScript("js/custom.js");
//     })

//     return (
//         <>
//             {/*Banner Start*/}
//             <div className="twm-home1-banner-section site-bg-gray bg-cover" style={{ backgroundImage: `url(${publicUrlFor("images/main-slider/slider1/bg1.jpg")})` }}>
//                 <div className="row">
//                     {/*Left Section*/}
//                     <div className="col-xl-6 col-lg-6 col-md-12">
//                         <div className="twm-bnr-left-section">
//                             <div className="twm-bnr-title-small">We Have <span className="site-text-primary">208,000+</span> Live Jobs</div>
//                             <div className="twm-bnr-title-large">Find the <span className="site-text-primary">job</span> that fits your life</div>
//                             <div className="twm-bnr-discription">Type your keyword, then click search to find your perfect job.</div>
//                             <div className="twm-bnr-search-bar">
//                                 <form>
//                                     <div className="row">
//                                         {/*Title*/}
//                                         <div className="form-group col-xl-3 col-lg-6 col-md-6">
//                                             <label>What</label>
//                                             <select className="wt-search-bar-select selectpicker" data-live-search="true" title="" id="j-Job_Title" data-bv-field="size">
//                                                 <option disabled value="" >Select Category</option>
//                                                 <option>Job Title</option>
//                                                 <option>Web Designer</option>
//                                                 <option>Developer</option>
//                                                 <option>Acountant</option>
//                                             </select>
//                                         </div>
//                                         {/*All Category*/}
//                                         <div className="form-group col-xl-3 col-lg-6 col-md-6">
//                                             <label>Type</label>
//                                             <select className="wt-search-bar-select selectpicker" data-live-search="true" title="" id="j-All_Category" data-bv-field="size">
//                                                 <option disabled value="" >Select Category</option>
//                                                 <option>All Category</option>
//                                                 <option>Web Designer</option>
//                                                 <option>Developer</option>
//                                                 <option>Acountant</option>
//                                             </select>
//                                         </div>
//                                         {/*Location*/}
//                                         <div className="form-group col-xl-3 col-lg-6 col-md-6">
//                                             <label>Location</label>
//                                             <div className="twm-inputicon-box">
//                                                 <input name="username" type="text" required className="form-control" placeholder="Search..." />
//                                                 <i className="twm-input-icon fas fa-map-marker-alt" />
//                                             </div>
//                                         </div>
//                                         {/*Find job btn*/}
//                                         <div className="form-group col-xl-3 col-lg-6 col-md-6">
//                                             <button type="button" className="site-button">Find Job</button>
//                                         </div>
//                                     </div>
//                                 </form>
//                             </div>
//                             <div className="twm-bnr-popular-search">
//                                 <span className="twm-title">Popular Searches:</span>
//                                 <NavLink to={publicUser.jobs.LIST}>Developer</NavLink> ,
//                                 <NavLink to={publicUser.jobs.LIST}>Designer</NavLink> ,
//                                 <NavLink to={publicUser.jobs.LIST}>Architect</NavLink> ,
//                                 <NavLink to={publicUser.jobs.LIST}>Engineer</NavLink> ...
//                             </div>
//                         </div>
//                     </div>
//                     {/*right Section*/}
//                     <div className="col-xl-6 col-lg-6 col-md-12 twm-bnr-right-section">
//                         <div className="twm-bnr-right-content">
//                             <div className="twm-img-bg-circle-area">
//                                 <div className="twm-img-bg-circle1 rotate-center"><span /></div>
//                                 <div className="twm-img-bg-circle2 rotate-center-reverse"><span /></div>
//                                 <div className="twm-img-bg-circle3"><span /></div>
//                             </div>
//                             <div className="twm-bnr-right-carousel">
//                                 <div className="owl-carousel twm-h1-bnr-carousal">
//                                     <div className="item">
//                                         <div className="slide-img">
//                                             <JobZImage src="images/main-slider/slider1/r-img1.png" alt="#" />
//                                         </div>
//                                     </div>
//                                     <div className="item">
//                                         <div className="slide-img">
//                                             <div className="slide-img">
//                                                 <JobZImage src="images/main-slider/slider1/r-img2.png" alt="#" />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="twm-bnr-blocks-position-wrap">
//                                     {/*icon-block-1*/}
//                                     <div className="twm-bnr-blocks twm-bnr-blocks-position-1">
//                                         <div className="twm-icon">
//                                             <JobZImage src="images/main-slider/slider1/icon-1.png" alt="" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="tw-count-number text-clr-sky">
//                                                 <span className="counter">
//                                                     <CountUp end={12} duration={10} />
//                                                 </span>K+
//                                             </div>
//                                             <p className="icon-content-info">Companies Jobs</p>
//                                         </div>
//                                     </div>
//                                     {/*icon-block-2*/}
//                                     <div className="twm-bnr-blocks twm-bnr-blocks-position-2">
//                                         <div className="twm-icon">
//                                             <JobZImage src="images/main-slider/slider1/icon-2.png" alt="" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="tw-count-number text-clr-pink">
//                                                 <span className="counter">
//                                                     <CountUp end={98} duration={10} />
//                                                 </span> +
//                                             </div>
//                                             <p className="icon-content-info">Job For Countries </p>
//                                         </div>
//                                     </div>
//                                     {/*icon-block-3*/}
//                                     <div className="twm-bnr-blocks-3 twm-bnr-blocks-position-3">
//                                         <div className="twm-pics">
//                                             <span><JobZImage src="images/main-slider/slider1/user/u-1.jpg" alt="" /></span>
//                                             <span><JobZImage src="images/main-slider/slider1/user/u-2.jpg" alt="" /></span>
//                                             <span><JobZImage src="images/main-slider/slider1/user/u-3.jpg" alt="" /></span>
//                                             <span><JobZImage src="images/main-slider/slider1/user/u-4.jpg" alt="" /></span>
//                                             <span><JobZImage src="images/main-slider/slider1/user/u-5.jpg" alt="" /></span>
//                                             <span><JobZImage src="images/main-slider/slider1/user/u-6.jpg" alt="" /></span>
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="tw-count-number text-clr-green">
//                                                 <span className="counter">
//                                                     <CountUp end={3} duration={10} />
//                                                 </span>K+
//                                             </div>
//                                             <p className="icon-content-info">Jobs Done</p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*Samll Ring Left*/}
//                             <div className="twm-small-ring-l slide-top-animation" />
//                             <div className="twm-small-ring-2 slide-top-animation" />
//                         </div>
//                     </div>
//                 </div>
//                 <div className="twm-gradient-text">
//                     Jobs
//                 </div>
//             </div>
//             {/*Banner End*/}
//             {/* HOW IT WORK SECTION START */}
//             <div className="section-full p-t120 p-b90 site-bg-white twm-how-it-work-area">
//                 <div className="container">
//                     {/* title="" START*/}
//                     <div className="section-head center wt-small-separator-outer">
//                         <div className="wt-small-separator site-text-primary">
//                             <div>Working Process</div>
//                         </div>
//                         <h2 className="wt-title">How It Works</h2>
//                     </div>
//                     {/* title="" END*/}
//                     <div className="twm-how-it-work-section">
//                         <div className="row">
//                             <div className="col-xl-4 col-lg-6 col-md-6">
//                                 <div className="twm-w-process-steps">
//                                     <span className="twm-large-number">01</span>
//                                     <div className="twm-w-pro-top bg-clr-sky">
//                                         <div className="twm-media">
//                                             <span><JobZImage src="images/work-process/icon1.png" alt="icon1" /></span>
//                                         </div>
//                                         <h4 className="twm-title">Register<br />Your Account</h4>
//                                     </div>
//                                     <p>You need to create an account to find the best and preferred job.</p>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-6">
//                                 <div className="twm-w-process-steps">
//                                     <span className="twm-large-number">02</span>
//                                     <div className="twm-w-pro-top bg-clr-pink">
//                                         <div className="twm-media">
//                                             <span><JobZImage src="images/work-process/icon2.png" alt="icon1" /></span>
//                                         </div>
//                                         <h4 className="twm-title">Apply <br />
//                                             For Dream Job</h4>
//                                     </div>
//                                     <p>You need to create an account to find the best and preferred job.</p>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-6">
//                                 <div className="twm-w-process-steps">
//                                     <span className="twm-large-number">03</span>
//                                     <div className="twm-w-pro-top bg-clr-green">
//                                         <div className="twm-media">
//                                             <span><JobZImage src="images/work-process/icon3.png" alt="icon1" /></span>
//                                         </div>
//                                         <h4 className="twm-title">Upload <br />Your Resume</h4>
//                                     </div>
//                                     <p>You need to create an account to find the best and preferred job.</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* HOW IT WORK SECTION END */}
//             {/* JOBS CATEGORIES SECTION START */}
//             <div className="section-full p-t120 p-b90 site-bg-gray twm-job-categories-area">
//                 <div className="container">
//                     <div className="wt-separator-two-part">
//                         <div className="row wt-separator-two-part-row">
//                             <div className="col-xl-5 col-lg-5 col-md-12 wt-separator-two-part-left">
//                                 {/* title="" START*/}
//                                 <div className="section-head left wt-small-separator-outer">
//                                     <div className="wt-small-separator site-text-primary">
//                                         <div>Jobs by Categories</div>
//                                     </div>
//                                     <h2 className="wt-title">Choose Your Desire Category</h2>
//                                 </div>
//                                 {/* title="" END*/}
//                             </div>
//                             <div className="col-xl-6 col-lg-6 col-md-12 wt-separator-two-part-right">
//                                 <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the  when an printer took.</p>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="twm-job-categories-section">
//                         <div className="job-categories-style1 m-b30">
//                             <div className="owl-carousel job-categories-carousel owl-btn-left-bottom ">
//                                 {/* COLUMNS 1 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-dashboard" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">9,185 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Business Development</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 2 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-project-management" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">3,205 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Project Management</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 3 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-note" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">2,100 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Content Writer</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 4 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-customer-support" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">1,500 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Costomer Services</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 5 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-bars" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">9,185 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Accounting / Finance</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 6 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-user" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">3,205 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Marketing</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 7 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-computer" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">2,100 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Design &amp; Art</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 8 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-coding" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">1,500 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Web Development</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 9 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-hr" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">9,185 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Human Resource</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 10 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-healthcare" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">3,205 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Health and Care </NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 11 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-repair" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">2,100 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Automotive Jobs</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 12 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-teacher" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">1,500 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Teaching / Education</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 13 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-bank" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">9,185 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Banking</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 14 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-deal" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">3,205 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Sales Marketing</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 15 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-tray" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">2,100 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Restaurant / Food</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 16 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-tower" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">1,500 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Telecommunications</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 17 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-lotus" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">9,185 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Fitness Trainer</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 18 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-camera-tripod" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">3,205 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Photography</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 19 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-multimedia" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">2,100 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Audio + Music</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 20 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-contract" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">1,500 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Real estate</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 {/* COLUMNS 21 */}
//                                 <div className="item ">
//                                     <div className="job-categories-block">
//                                         <div className="twm-media">
//                                             <div className="flaticon-engineer" />
//                                         </div>
//                                         <div className="twm-content">
//                                             <div className="twm-jobs-available">9,185 Jobs</div>
//                                             <NavLink to={publicUser.jobs.DETAIL1}>Construction</NavLink>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="text-right job-categories-btn">
//                             <NavLink to={publicUser.jobs.GRID} className=" site-button">All Categories</NavLink>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* JOBS CATEGORIES SECTION END */}
//             {/* EXPLORE NEW LIFE START */}
//             <div className="section-full p-t120 p-b120 twm-explore-area bg-cover " style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-1.jpg")})` }}>
//                 <div className="container">
//                     <div className="section-content">
//                         <div className="row">
//                             <div className="col-lg-4 col-md-12">
//                                 <div className="twm-explore-media-wrap">
//                                     <div className="twm-media">
//                                         <JobZImage src="images/gir-large.png" alt="" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-8 col-md-12">
//                                 <div className="twm-explore-content-outer">
//                                     <div className="twm-explore-content">
//                                         <div className="twm-l-line-1" />
//                                         <div className="twm-l-line-2" />
//                                         <div className="twm-r-circle-1" />
//                                         <div className="twm-r-circle-2" />
//                                         <div className="twm-title-small">Explore New Life</div>
//                                         <div className="twm-title-large">
//                                             <h2>Don’t just find. be found
//                                                 put your CV in front of
//                                                 great employers </h2>
//                                             <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the  when an printer took.</p>
//                                         </div>
//                                         <div className="twm-upload-file">
//                                             <button type="button" className="site-button">Upload Your Resume <i className="feather-upload" /></button>
//                                         </div>
//                                     </div>
//                                     <div className="twm-bold-circle-right" />
//                                     <div className="twm-bold-circle-left" />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* EXPLORE NEW LIFE END */}
//             {/* TOP COMPANIES START */}
//             <div className="section-full p-t120  site-bg-white twm-companies-wrap">
//                 {/* title="" START*/}
//                 <div className="section-head center wt-small-separator-outer">
//                     <div className="wt-small-separator site-text-primary">
//                         <div>Top Companies</div>
//                     </div>
//                     <h2 className="wt-title">Get hired in top companies</h2>
//                 </div>
//                 {/* title="" END*/}
//                 <div className="container">
//                     <div className="section-content">
//                         <div className="owl-carousel home-client-carousel2 owl-btn-vertical-center">
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w1.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w2.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w3.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w4.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w5.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w6.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w1.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w2.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w3.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                             <div className="item">
//                                 <div className="ow-client-logo">
//                                     <div className="client-logo client-logo-media">
//                                         <NavLink to={publicUser.employer.LIST}><JobZImage src="images/client-logo/w5.png" alt="" /></NavLink></div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="twm-company-approch-outer">
//                     <div className="twm-company-approch">
//                         <div className="row">
//                             {/*block 1*/}
//                             <div className="col-lg-4 col-md-12">
//                                 <div className="counter-outer-two">
//                                     <div className="icon-content">
//                                         <div className="tw-count-number text-clr-sky">
//                                             <span className="counter">
//                                                 <CountUp end={5} duration={10} />
//                                             </span>M+</div>
//                                         <p className="icon-content-info">Million daily active users</p>
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*block 2*/}
//                             <div className="col-lg-4 col-md-12">
//                                 <div className="counter-outer-two">
//                                     <div className="icon-content">
//                                         <div className="tw-count-number text-clr-pink">
//                                             <span className="counter">
//                                                 <CountUp end={9} duration={10} />
//                                             </span>K+</div>
//                                         <p className="icon-content-info">Open job positions</p>
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*block 3*/}
//                             <div className="col-lg-4 col-md-12">
//                                 <div className="counter-outer-two">
//                                     <div className="icon-content">
//                                         <div className="tw-count-number text-clr-green">
//                                             <span className="counter">
//                                                 <CountUp end={2} duration={10} />
//                                             </span>M+</div>
//                                         <p className="icon-content-info">Million stories shared</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* TOP COMPANIES END */}
//             {/* JOB POST START */}
//             <div className="section-full p-t120 p-b90 site-bg-light-purple twm-bg-ring-wrap">
//                 <div className="twm-bg-ring-right" />
//                 <div className="twm-bg-ring-left" />
//                 <div className="container">
//                     {/* title="" START*/}
//                     <div className="section-head center wt-small-separator-outer">
//                         <div className="wt-small-separator site-text-primary">
//                             <div>All Jobs Post</div>
//                         </div>
//                         <h2 className="wt-title">Find Your Career You Deserve it</h2>
//                     </div>
//                     {/* title="" END*/}
//                     <div className="section-content">
//                         <div className="twm-jobs-list-wrap">
//                             <ul>
//                                 <li>
//                                     <div className="twm-jobs-list-style1 mb-5">
//                                         <div className="twm-media">
//                                             <JobZImage src="images/jobs-company/pic1.jpg" alt="#" />
//                                         </div>
//                                         <div className="twm-mid-content">
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                                 <h4>Senior Web Designer , Developer  <span className="twm-job-post-duration">/ 1 days ago</span></h4>
//                                             </NavLink>
//                                             <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                             <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                         </div>
//                                         <div className="twm-right-content">
//                                             <div className="twm-jobs-category green"><span className="twm-bg-green">New</span></div>
//                                             <div className="twm-jobs-amount">$2500 <span>/ Month</span></div>
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Browse Job</NavLink>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li>
//                                     <div className="twm-jobs-list-style1 mb-5">
//                                         <div className="twm-media">
//                                             <JobZImage src="images/jobs-company/pic2.jpg" alt="#" />
//                                         </div>
//                                         <div className="twm-mid-content">
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                                 <h4>Need Senior Rolling Stock Technician<span className="twm-job-post-duration">/ 15 days ago</span></h4>
//                                             </NavLink>
//                                             <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                             <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                         </div>
//                                         <div className="twm-right-content">
//                                             <div className="twm-jobs-category green"><span className="twm-bg-brown">Intership</span></div>
//                                             <div className="twm-jobs-amount">$2000<span>/ Month</span></div>
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Browse Job</NavLink>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li>
//                                     <div className="twm-jobs-list-style1 mb-5">
//                                         <div className="twm-media">
//                                             <JobZImage src="images/jobs-company/pic3.jpg" alt="#" />
//                                         </div>
//                                         <div className="twm-mid-content">
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                                 <h4 className="twm-job-title">IT Department Manager &amp; Blogger-Entrepenour  <span className="twm-job-post-duration">/ 6 Month ago</span></h4>
//                                             </NavLink>
//                                             <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                             <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                         </div>
//                                         <div className="twm-right-content">
//                                             <div className="twm-jobs-category green"><span className="twm-bg-purple">Fulltime</span></div>
//                                             <div className="twm-jobs-amount">$1500 <span>/ Month</span></div>
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Browse Job</NavLink>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li>
//                                     <div className="twm-jobs-list-style1 mb-5">
//                                         <div className="twm-media">
//                                             <JobZImage src="images/jobs-company/pic4.jpg" alt="#" />
//                                         </div>
//                                         <div className="twm-mid-content">
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                                 <h4 className="twm-job-title">Art Production Specialist   <span className="twm-job-post-duration">/ 2 days ago</span></h4>
//                                             </NavLink>
//                                             <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                             <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                         </div>
//                                         <div className="twm-right-content">
//                                             <div className="twm-jobs-category green"><span className="twm-bg-sky">Freelancer</span></div>
//                                             <div className="twm-jobs-amount">$1200<span>/ Month</span></div>
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Browse Job</NavLink>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li>
//                                     <div className="twm-jobs-list-style1 mb-5">
//                                         <div className="twm-media">
//                                             <JobZImage src="images/jobs-company/pic5.jpg" alt="#" />
//                                         </div>
//                                         <div className="twm-mid-content">
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                                 <h4 className="twm-job-title">Recreation &amp; Fitness Worker   <span className="twm-job-post-duration">/ 1 days ago</span></h4>
//                                             </NavLink>
//                                             <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                             <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                         </div>
//                                         <div className="twm-right-content">
//                                             <div className="twm-jobs-category green"><span className="twm-bg-golden">Temporary</span></div>
//                                             <div className="twm-jobs-amount">$1700 <span>/ Month</span></div>
//                                             <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Browse Job</NavLink>
//                                         </div>
//                                     </div>
//                                 </li>
//                             </ul>
//                             <div className="text-center m-b30">
//                                 <NavLink to={publicUser.jobs.LIST} className=" site-button">Browse All Jobs</NavLink>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* JOB POST END */}
//             {/* TESTIMONIAL SECTION START */}
//             <div className="section-full p-t120 p-b90 site-bg-white twm-testimonial-1-area">
//                 <div className="container">
//                     <div className="wt-separator-two-part">
//                         <div className="row wt-separator-two-part-row">
//                             <div className="col-xl-5 col-lg-6 col-md-12 wt-separator-two-part-left">
//                                 {/* title="" START*/}
//                                 <div className="section-head left wt-small-separator-outer">
//                                     <div className="wt-small-separator site-text-primary">
//                                         <div>Clients Testimonials</div>
//                                     </div>
//                                     <h2 className="wt-title">What Our Customers Say About Us</h2>
//                                 </div>
//                                 {/* title="" END*/}
//                             </div>
//                         </div>
//                     </div>
//                     <div className="section-content">
//                         <div className="owl-carousel twm-testimonial-1-carousel owl-btn-bottom-center ">
//                             {/* COLUMNS 1 */}
//                             <div className="item ">
//                                 <div className="twm-testimonial-1">
//                                     <div className="twm-testimonial-1-content">
//                                         <div className="twm-testi-media">
//                                             <JobZImage src="images/testimonials/pic-1.png" alt="#" />
//                                         </div>
//                                         <div className="twm-testi-content">
//                                             <div className="twm-quote">
//                                                 <JobZImage src="images/quote-dark.png" alt="" />
//                                             </div>
//                                             <div className="twm-testi-info">I just got a job that I applied for via careerfy! I used the site all the time during my job hunt.</div>
//                                             <div className="twm-testi-detail">
//                                                 <div className="twm-testi-name">Nikola Tesla</div>
//                                                 <div className="twm-testi-position">Accountant</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             {/* COLUMNS 2 */}
//                             <div className="item ">
//                                 <div className="twm-testimonial-1">
//                                     <div className="twm-testimonial-1-content">
//                                         <div className="twm-testi-media">
//                                             <JobZImage src="images/testimonials/pic-2.png" alt="#" />
//                                         </div>
//                                         <div className="twm-testi-content">
//                                             <div className="twm-quote">
//                                                 <JobZImage src="images/quote-dark.png" alt="" />
//                                             </div>
//                                             <div className="twm-testi-info">I just got a job that I applied for via careerfy! I used the site all the time during my job hunt.</div>
//                                             <div className="twm-testi-detail">
//                                                 <div className="twm-testi-name">Nikola Tesla</div>
//                                                 <div className="twm-testi-position">Accountant</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             {/* COLUMNS 3 */}
//                             <div className="item ">
//                                 <div className="twm-testimonial-1">
//                                     <div className="twm-testimonial-1-content">
//                                         <div className="twm-testi-media">
//                                             <JobZImage src="images/testimonials/pic-3.png" alt="#" />
//                                         </div>
//                                         <div className="twm-testi-content">
//                                             <div className="twm-quote">
//                                                 <JobZImage src="images/quote-dark.png" alt="" />
//                                             </div>
//                                             <div className="twm-testi-info">I just got a job that I applied for via careerfy! I used the site all the time during my job hunt.</div>
//                                             <div className="twm-testi-detail">
//                                                 <div className="twm-testi-name">Nikola Tesla</div>
//                                                 <div className="twm-testi-position">Accountant</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             {/* COLUMNS 4 */}
//                             <div className="item ">
//                                 <div className="twm-testimonial-1">
//                                     <div className="twm-testimonial-1-content">
//                                         <div className="twm-testi-media">
//                                             <JobZImage src="images/testimonials/pic-2.png" alt="#" />
//                                         </div>
//                                         <div className="twm-testi-content">
//                                             <div className="twm-quote">
//                                                 <JobZImage src="images/quote-dark.png" alt="" />
//                                             </div>
//                                             <div className="twm-testi-info">I just got a job that I applied for via careerfy! I used the site all the time during my job hunt.</div>
//                                             <div className="twm-testi-detail">
//                                                 <div className="twm-testi-name">Nikola Tesla</div>
//                                                 <div className="twm-testi-position">Accountant</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             {/* COLUMNS 5 */}
//                             <div className="item ">
//                                 <div className="twm-testimonial-1">
//                                     <div className="twm-testimonial-1-content">
//                                         <div className="twm-testi-media">
//                                             <JobZImage src="images/testimonials/pic-1.png" alt="#" />
//                                         </div>
//                                         <div className="twm-testi-content">
//                                             <div className="twm-quote">
//                                                 <JobZImage src="images/quote-dark.png" alt="" />
//                                             </div>
//                                             <div className="twm-testi-info">I just got a job that I applied for via careerfy! I used the site all the time during my job hunt.</div>
//                                             <div className="twm-testi-detail">
//                                                 <div className="twm-testi-name">Nikola Tesla</div>
//                                                 <div className="twm-testi-position">Accountant</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* TESTIMONIAL SECTION END */}
//             {/* OUR BLOG START */}
//             <div className="section-full p-t120 p-b90 site-bg-gray">
//                 <div className="container">
//                     {/* title="" START*/}
//                     <div className="section-head center wt-small-separator-outer">
//                         <div className="wt-small-separator site-text-primary">
//                             <div>Our Blogs</div>
//                         </div>
//                         <h2 className="wt-title">Latest Article</h2>
//                     </div>
//                     {/* title="" END*/}
//                     <div className="section-content">
//                         <div className="twm-blog-post-1-outer-wrap">
//                             <div className="owl-carousel twm-la-home-blog owl-btn-bottom-center">
//                                 <div className="item">
//                                     {/*Block one*/}
//                                     <div className="blog-post twm-blog-post-1-outer">
//                                         <div className="wt-post-media">
//                                             <NavLink to={publicUser.blog.DETAIL}><JobZImage src="images/blog/latest/bg1.jpg" alt="" /></NavLink>
//                                         </div>
//                                         <div className="wt-post-info">
//                                             <div className="wt-post-meta ">
//                                                 <ul>
//                                                     <li className="post-date">March 05, 2023</li>
//                                                     <li className="post-author">By <NavLink to={publicUser.candidate.DETAIL1}>Mark Petter</NavLink></li>
//                                                 </ul>
//                                             </div>
//                                             <div className="wt-post-title ">
//                                                 <h4 className="post-title">
//                                                     <NavLink to={publicUser.blog.DETAIL}>How to convince recruiters and get your dream job</NavLink>
//                                                 </h4>
//                                             </div>
//                                             <div className="wt-post-text ">
//                                                 <p>
//                                                     New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.
//                                                 </p>
//                                             </div>
//                                             <div className="wt-post-readmore ">
//                                                 <NavLink to={publicUser.blog.DETAIL} className="site-button-link site-text-primary">Read More</NavLink>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="item">
//                                     {/*Block two*/}
//                                     <div className="blog-post twm-blog-post-1-outer">
//                                         <div className="wt-post-media">
//                                             <NavLink to={publicUser.blog.DETAIL}><JobZImage src="images/blog/latest/bg2.jpg" alt="" /></NavLink>
//                                         </div>
//                                         <div className="wt-post-info">
//                                             <div className="wt-post-meta ">
//                                                 <ul>
//                                                     <li className="post-date">March 05, 2023</li>
//                                                     <li className="post-author">By <NavLink to={publicUser.candidate.DETAIL1}>David Wish</NavLink></li>
//                                                 </ul>
//                                             </div>
//                                             <div className="wt-post-title ">
//                                                 <h4 className="post-title">
//                                                     <NavLink to={publicUser.blog.DETAIL}>5 things to know about the March
//                                                         2023 jobs report</NavLink>
//                                                 </h4>
//                                             </div>
//                                             <div className="wt-post-text ">
//                                                 <p>
//                                                     New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.
//                                                 </p>
//                                             </div>
//                                             <div className="wt-post-readmore ">
//                                                 <NavLink to={publicUser.blog.DETAIL} className="site-button-link site-text-primary">Read More</NavLink>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="item">
//                                     {/*Block three*/}
//                                     <div className="blog-post twm-blog-post-1-outer">
//                                         <div className="wt-post-media">
//                                             <NavLink to={publicUser.blog.DETAIL}><JobZImage src="images/blog/latest/bg3.jpg" alt="" /></NavLink>
//                                         </div>
//                                         <div className="wt-post-info">
//                                             <div className="wt-post-meta ">
//                                                 <ul>
//                                                     <li className="post-date">March 05, 2023</li>
//                                                     <li className="post-author">By <NavLink to={publicUser.candidate.DETAIL1}>Mike Doe</NavLink></li>
//                                                 </ul>
//                                             </div>
//                                             <div className="wt-post-title ">
//                                                 <h4 className="post-title">
//                                                     <NavLink to={publicUser.blog.DETAIL}>Job Board is the most important
//                                                         sector in the world</NavLink>
//                                                 </h4>
//                                             </div>
//                                             <div className="wt-post-text ">
//                                                 <p>
//                                                     New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.
//                                                 </p>
//                                             </div>
//                                             <div className="wt-post-readmore ">
//                                                 <NavLink to={publicUser.blog.DETAIL} className="site-button-link site-text-primary">Read More</NavLink>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="item">
//                                     {/*Block Four*/}
//                                     <div className="blog-post twm-blog-post-1-outer">
//                                         <div className="wt-post-media">
//                                             <NavLink to={publicUser.blog.DETAIL}><JobZImage src="images/blog/latest/bg1.jpg" alt="" /></NavLink>
//                                         </div>
//                                         <div className="wt-post-info">
//                                             <div className="wt-post-meta ">
//                                                 <ul>
//                                                     <li className="post-date">March 05, 2023</li>
//                                                     <li className="post-author">By <NavLink to={publicUser.candidate.DETAIL1}>Mark Petter</NavLink></li>
//                                                 </ul>
//                                             </div>
//                                             <div className="wt-post-title ">
//                                                 <h4 className="post-title">
//                                                     <NavLink to={publicUser.blog.DETAIL}>How to convince recruiters and get your dream job</NavLink>
//                                                 </h4>
//                                             </div>
//                                             <div className="wt-post-text ">
//                                                 <p>
//                                                     New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.
//                                                 </p>
//                                             </div>
//                                             <div className="wt-post-readmore ">
//                                                 <NavLink to={publicUser.blog.DETAIL} className="site-button-link site-text-primary">Read More</NavLink>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="item">
//                                     {/*Block Five*/}
//                                     <div className="blog-post twm-blog-post-1-outer">
//                                         <div className="wt-post-media">
//                                             <NavLink to={publicUser.blog.DETAIL}><JobZImage src="images/blog/latest/bg2.jpg" alt="" /></NavLink>
//                                         </div>
//                                         <div className="wt-post-info">
//                                             <div className="wt-post-meta ">
//                                                 <ul>
//                                                     <li className="post-date">March 05, 2023</li>
//                                                     <li className="post-author">By <NavLink to={publicUser.candidate.DETAIL1}>David Wish</NavLink></li>
//                                                 </ul>
//                                             </div>
//                                             <div className="wt-post-title ">
//                                                 <h4 className="post-title">
//                                                     <NavLink to={publicUser.blog.DETAIL}>5 things to know about the March
//                                                         2023 jobs report</NavLink>
//                                                 </h4>
//                                             </div>
//                                             <div className="wt-post-text ">
//                                                 <p>
//                                                     New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.
//                                                 </p>
//                                             </div>
//                                             <div className="wt-post-readmore ">
//                                                 <NavLink to={publicUser.blog.DETAIL} className="site-button-link site-text-primary">Read More</NavLink>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="item">
//                                     {/*Block Six*/}
//                                     <div className="blog-post twm-blog-post-1-outer">
//                                         <div className="wt-post-media">
//                                             <NavLink to={publicUser.blog.DETAIL}><JobZImage src="images/blog/latest/bg3.jpg" alt="" /></NavLink>
//                                         </div>
//                                         <div className="wt-post-info">
//                                             <div className="wt-post-meta ">
//                                                 <ul>
//                                                     <li className="post-date">March 05, 2023</li>
//                                                     <li className="post-author">By <NavLink to={publicUser.candidate.DETAIL1}>Mike Doe</NavLink></li>
//                                                 </ul>
//                                             </div>
//                                             <div className="wt-post-title ">
//                                                 <h4 className="post-title">
//                                                     <NavLink to={publicUser.blog.DETAIL}>Job Board is the most important
//                                                         sector in the world</NavLink>
//                                                 </h4>
//                                             </div>
//                                             <div className="wt-post-text ">
//                                                 <p>
//                                                     New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.
//                                                 </p>
//                                             </div>
//                                             <div className="wt-post-readmore ">
//                                                 <NavLink to={publicUser.blog.DETAIL} className="site-button-link site-text-primary">Read More</NavLink>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* OUR BLOG END */}
//         </>
//     )
// }

// export default Home1Page;